import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=6b56b7ac&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=6b56b7ac&prod&lang=scss"
import style1 from "./Information.vue?vue&type=style&index=1&id=6b56b7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56b7ac",
  null
  
)

export default component.exports